import React from "react";
import * as Yup from 'yup';
import { Frazione, Comune, ClienteData } from "../../generated"
import { ComuniAutocomplete } from "../../comuni/components/comuniAutocomplete";
import { FrazioneSelector } from "../../comuni/components/FrazioneSelector";
import FormGenderSelector from "../../common/components/genderSelector";
import { GeocoderMap } from "../../common/components/GeocoderMap";
import { Forms, Divider } from "../../common/components/CmForms";
import { CustomerCodeSelector } from "./CustomerCodeSelector";
const { Form, FormSwitch, FormText, ActionBar } = Forms<ClienteData>()

interface Props {
    customer: ClienteData;
    onSubmit: (customer: ClienteData) => void;
    onCancel: () => void;
    idCliente: number | null;
}
export const addressDescription = (values: ClienteData) => {
    const arr: string[] = [];
    if (values.indirizzo)
        arr.push(values.indirizzo)
    if (values.frazione?.nomeFrazione && values.frazione.nomeFrazione?.toLowerCase() != values.comune?.nomeComune?.toLowerCase())
        arr.push(values.frazione.nomeFrazione);
    if (values.comune?.nomeComune)
        arr.push(values.comune?.nomeComune);
    if (values.comune?.provincia)
        arr.push(values.comune.provincia)
    return arr.join(", ");
}
export default class CustomerForm extends React.Component<Props> {

    private static validationSchema = Yup.object<Partial<ClienteData>>({
        cognomeProprietario: Yup
            .string()
            .required('Campo obbligatorio'),
        indirizzo: Yup
            .string()
            .required('Campo obbligatorio'),
        frazione: Yup
            .object<Frazione>()
            .required('Campo obbligatorio'),
        comune: Yup
            .object<Comune>()
            .required('Campo obbligatorio'),
        email: Yup
            .string()
            .email("L'email inserita non è valida")
            .notRequired()
            .nullable() as any,
        codiceFiscale: Yup
            .string()
            .max(16, "Campo non valido")
            .notRequired()
            .nullable() as any,
    })
    render() {
        const { customer } = this.props;
        return (
            <Form
                onSubmit={this.props.onSubmit}
                initialValues={customer}
                validationSchema={CustomerForm.validationSchema}
            >
                {
                    ({ set, values, errors }) =>
                        <div className="pb-3">

                            <div className="row d-flex align-items-end">
                                <div className="col-12">
                                    <Divider caption="Dati identificativi" />
                                </div>
                                <div className="col-12 col-md-6">
                                    <CustomerCodeSelector
                                        label="Codice Cliente"
                                        idCliente={this.props.idCliente}
                                        onChange={code => set("codiceClienteAzienda", code)}
                                        code={values.codiceClienteAzienda}
                                    />
                                </div>
                                <div className="col-12 col-md-6 d-flex flex-wrap">
                                    <div className="me-5">
                                        <FormSwitch
                                            name="azienda"
                                            label="Azienda"
                                        />
                                    </div>
                                    <div className="me-5">
                                        <FormSwitch
                                            name="dismessa"
                                            label="Dismesso"
                                        />
                                    </div>
                                    {!values.azienda &&
                                        <div className="me-5">
                                            <FormGenderSelector
                                                onChange={sesso => set("sesso", sesso?.key)}
                                                value={values.sesso ?? null}
                                            />
                                        </div>}
                                </div>
                            </div>
                            <div style={{ opacity: values.dismessa ? "90%" : undefined }}>
                                <div className="row">
                                    <div className={values.azienda ? "col-12" : "col-12 col-md-6"}>
                                        <FormText
                                            name="cognomeProprietario"
                                            label={values.azienda ? "Ragione Sociale" : "Cognome"}
                                            readOnly={values.dismessa}
                                        />
                                    </div>
                                    {!values.azienda && <div className="col-12 col-md-6">
                                        <FormText
                                            name="nomeProprietario"
                                            label="Nome"
                                            readOnly={values.dismessa}
                                        />
                                    </div>}
                                    <div className="col-12 col-md-6">
                                        <FormText
                                            name="responsabile"
                                            label="Responsabile (Inquilino)"
                                            readOnly={values.dismessa}
                                        />
                                    </div>
                                </div>
                                <Divider caption="Dati Fatturazione" />
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <FormText
                                            className="text-uppercase"
                                            name="codiceFiscale"
                                            label="Codice Fiscale"
                                            readOnly={values.dismessa}
                                        />
                                    </div>
                                    {values.azienda && <>
                                        <div className="col-12 col-md-6">
                                            <FormText
                                                name="partitaIva"
                                                label="Partita IVA"
                                                readOnly={values.dismessa}
                                            />
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <FormText
                                                type="email"
                                                name="pec"
                                                label="Pec"
                                                readOnly={values.dismessa}
                                            />
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <FormText
                                                name="sdi"
                                                label="Codice Univoco"
                                                readOnly={values.dismessa}
                                            />
                                        </div>
                                    </>}
                                </div>
                                <Divider caption="Contatti" />
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <FormText
                                            name="telefono"
                                            label="Telefono"
                                            readOnly={values.dismessa}
                                        />
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <FormText
                                            name="cell"
                                            label="Cellulare"
                                            readOnly={values.dismessa}
                                        />
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <FormText
                                            name="email"
                                            label="Email"
                                            readOnly={values.dismessa}
                                        />

                                    </div>
                                    <div className="col-12 col-md-6">
                                        <FormText
                                            name="fax"
                                            label="Fax"
                                            readOnly={values.dismessa}
                                        />
                                    </div>
                                    <div className="col-12 col-md-12">
                                        <FormText
                                            name="notaCliente"
                                            label="Nota Cliente"
                                            readOnly={values.dismessa}
                                        />
                                    </div>
                                </div>

                                <Divider caption="Dove si trova" />
                                <div className="row">
                                    <div className="col-12 col-lg-4">
                                        <div className="row">
                                            <div className="col-12">
                                                <ComuniAutocomplete
                                                    label="Comune"
                                                    onChange={async comune => {
                                                        await set("comune", comune ?? undefined);
                                                        await set("cap", comune?.cap);
                                                    }}
                                                    value={values.comune}
                                                    error={errors.comune}
                                                    readOnly={values.dismessa}
                                                />
                                            </div>
                                            <div className="col-12">
                                                {values.comune && <FrazioneSelector
                                                    label="Frazione"
                                                    codFisComune={values.comune.codFisComune}
                                                    onChange={frazione => set("frazione", frazione ?? undefined)}
                                                    value={values.frazione ?? null}
                                                    error={errors.frazione}
                                                    readonly={values.dismessa}
                                                />}
                                            </div>
                                            <div className="col-12 col-md-2">
                                                <FormText
                                                    name="cap"
                                                    label="Cap"
                                                    readOnly={values.dismessa}
                                                />
                                            </div>
                                            <div className="col-12 col-md-8">
                                                <FormText
                                                    name="indirizzo"
                                                    label="Indirizzo"
                                                    readOnly={values.dismessa}
                                                />
                                            </div>
                                            <div className="col-12 col-md-2">
                                                <FormText
                                                    name="piano"
                                                    label="Piano"
                                                    readOnly={values.dismessa}
                                                />
                                            </div>
                                        </div>
                                        <span className="fw-bold text-uppercase w-100" >
                                            Dati catastali
                                        </span>
                                        <div className={`bg-theme`} style={{ height: 3, borderRadius: 30, maxWidth: 250 }}></div>
                                        <div className="row">
                                            <div className="col-12 col-md-6">
                                                <FormText
                                                    name="sezione"
                                                    label="Sezione"
                                                    readOnly={values.dismessa}
                                                />
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <FormText
                                                    name="foglio"
                                                    label="Foglio"
                                                    readOnly={values.dismessa}
                                                />
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <FormText
                                                    name="particella"
                                                    label="Particella"
                                                    readOnly={values.dismessa}
                                                />
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <FormText
                                                    name="sub"
                                                    label="Subalterno"
                                                    readOnly={values.dismessa}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-lg-8">
                                        <GeocoderMap
                                            hint={addressDescription(values)}
                                            latitude={values.latitudine ?? undefined}
                                            longitude={values.longitudine ?? undefined}
                                            onChange={(lat, lng) => { set("latitudine", lat); set("longitudine", lng) }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <ActionBar
                                onCancel={this.props.onCancel}
                            />
                        </div>
                }
            </Form>
        );
    }
}
